import { NewsContentType } from '@/types/enum';
const image1 = 'https://timg.zgswcn.com/upload/uploadImage/20220920/1663662647431095037.png';
export default {
  id: '20220920', //  模块 id
  title: '线上线下跨界联动 叮咚买菜助力餐企将火锅大餐搬回家', // 标题
  origin: '2022-09-20 16:31:36 来源：中国商报网', // 新闻来源
  editor: '记者 贺阳', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '年轻人逐渐回归对自己身体和生活状态的关注，“养生”成了年轻人的潮流选择，消费市场也刮起了大健康风潮。今年秋冬，叮咚买菜等各大平台重点打造“养生派”火锅，推出了“番茄牛尾火锅”“醉鸡煲火锅”“当归羊肉火锅”等数十款创新锅底，既是火锅又是滋补汤品，将品质和健康放在首位。同时，叮咚买菜今年和众多线下火锅知名品牌合作，将餐饮企业与生鲜电商进行优势嫁接，让消费者在家也能享受和火锅店一样的体验和正宗的口味。',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '既是火锅也是汤品',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '年轻人的养生意识正在飞速发展。新华网发布的《Z世代营养消费趋势报告》显示，年轻人正在成为当下养生消费的主力军，18至35岁的年轻消费人群占健康养生消费人群的83.7%。而“食补”则是主要养生方式之一。因此今年的火锅在多元化消费需求的基础上，增加创意性养生型锅底。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '据了解，叮咚买菜推出的自有品牌“叮咚大满冠”系列火锅汤底，全部使用真材实料，小火慢熬，既是火锅，也是滋补汤品。叮咚买菜预制菜味型师朱鹤介绍，“番茄牛尾火锅”选用乌拉圭谷饲牛的牛尾，这一牛身上最活跃的部位，肉质鲜美、富含胶质。用煸炒过后的新鲜番茄和牛尾一起小火慢熬2个小时，直到牛尾里的胶质溶于汤中，牛尾肉刚好软烂脱骨。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '线上线下联动 把原汁原味搬回家',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '在家聚餐吃火锅，特别有温暖感和家的氛围。为了让消费者在家也能享受到火锅店一样的体验，叮咚买菜和左庭右院、望蓉城、精悦蓉、老诚一锅等众多知名线下火锅店合作，推出全新研发的联名火锅套餐。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '“天冷以后，我经常在网上买火锅。”在一家互联网公司工作的刘女士说道，“一方面，送上门在家吃更省时省力；另一方面，现在生鲜电商平台能买到的火锅品类非常丰富，川式、港式、东南亚各种风味的锅底、全套的火锅配菜、特色的调味料都能买齐。”',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '叮咚买菜预制菜负责人欧厚喜介绍，每一个餐饮企业都有他们独特的、被用户所认可的味道，我们怀着对行业的敬畏之心，和线下餐饮企业合作，希望尽最大努力去还原它的味道、吃法，并在原材料和品价比上进行升级。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '比如，在和“左庭右院”合作研发它的招牌“特色牛腩鸳鸯锅”的时候，就遇到了一个难题：如何让锅底中的白萝卜锁住水分，保持鲜活的气息的同时，又不能煮得太烂或太生。为了做好这块萝卜，团队前后做了100次测试，最后找到了一个解决方案：把煮好的萝卜在零下12度进行速冻，把外表的皮定型，再将萝卜迅速浸入0摄氏度的纯净水，萝卜外面迅速形成了一层薄薄的冰，锁住了水分。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '欧厚喜也表示，今年整个火锅季将从9月延续到明年的2月，期间我们将不断研发出更多差异化、创新性、兼顾口味和健康的火锅商品，来满足各个年龄段、消费偏好的食客的需求，为他们提供吃火锅的多元化选择，同时助力更多餐饮品牌线上化，走进更多用户的家庭。',
    },
  ],
};
